import 'tippy.js/dist/themes/light.css';
import 'tippy.js/dist/tippy.css';

import './app.css';
import { Flex, Box } from 'rebass';
import { Redirect, Route, Switch } from 'react-router-dom';
import React from 'react';

// import AndroidSaveBanner from 'app/banners/android-save-banner';
import Auth from '../auth';
import { AppContainer } from './styled';
import { QueryContextProvider } from '../contexts/query';
import { ServerErrorProvider, ServerErrorPopup } from './server-error-popup/index';
import AppCheckmark from '../ui/checkmark';
import AuthorizedContext from '../contexts/authorized';
import BrowserVersionsWrap from './browser-versions/wrap';
import Memoir from '../collections';
import CompleteOnboarding from '../members/complete-profile/complete-get-started';
import CompleteProfile from '../members/complete-profile';
import ConnectionStatus from './connection-status';
import DesktopSidebar from './navigation/sidebar/desktop';
// import Friends from '../friends';
import GlobalNewStory from '../stories/new/global';
// import Header from './navigation/header';
import JSONAPIContext from './json-api-client/context';
import MobileDrawer from './mobile-drawer';
import MobileNavigation from './navigation/mobile';
import ModalRoutes from './modal-routes';
// import MyStoriesPage from '../stories/pages/my-stories';
// import Notifications from '../notifications';
import Profile from '../members/profile';
import PublicConnections from '../public-connections';
import PublicMedia from '../public-media';
// import SharedWithMePage from '../stories/pages/shared-with-me';
import Stories from '../stories/stories';
import StoryRequestDetail from '../story-requests/detail';
import SubscriptionCodeStorage from '../subscriptions/code-storage';
import UnloadWarning from './unload-warning';
import UploadManager from '../story-media/upload-manager';
import TellAStory from 'stories/tell-a-story/index';
import BabysFirstYear from 'babys-first-year/index';
import PasswordResetPage from 'auth/reset';
import ForgotPasswordPage from 'auth/forgot-password';
import PublicFamilyTree from 'family-tree/public/PublicFamilyTree';
import RecipientInvitePage from 'family-tree/public/RecipientInvite';
import GiftCertificate from 'gift-certificate/index';
import Snooze from 'snooze-reminders/index';
import LoginSignUp from '../babys-first-year/LoginSignup';
import FinalVideoPreview from './FinalVideoPreview.js';
import { DrawerProvider } from 'contexts/DrawerContext';
import FounderWelcome from './FounderWelcome';
import WatchMeGrowOnBoarding from 'collections/watch-me-grow/onboarding/index';
import OrderType from 'gift-certificate/OrderType';
import { BookPagesProvider } from 'stories/book-pages-context';
import AccountDashboard from 'account-dashboard/index';
import ShopifyOnboardingPage from 'account-dashboard/shopify-onboarding/index';

const App = () => {
  return (
    <BrowserVersionsWrap>
      <AppContainer>
        <ServerErrorProvider>
          <JSONAPIContext>
            <QueryContextProvider>
              <Route
                path="/password/:id/reset"
                component={PasswordResetPage}
              />
              {/* Request-a-reset page. Nested under /password so it's already covered by
                  checkIfPublicRoute + AuthMember's `/password` handling (see auth/member.js)
                  with no further changes there — same treatment as the reset page above. */}
              <Route
                path="/password/forgot"
                component={ForgotPasswordPage}
              />
              <Auth>
                <Route
                  path="/subscriptions/:subscriptionCode"
                  component={SubscriptionCodeStorage}
                />
                <ConnectionStatus />
                <UnloadWarning />
                <Switch>
                  <Route path="/member/:id" component={PublicConnections} />
                  <Route path="/play/:id" component={PublicMedia} />
                  {/* Public QR-linked Talking Family Tree (guest account auto-created). */}
                  <Route path="/family_tree/:slug" component={PublicFamilyTree} />
                  {/* Public recipient invitation flow (guest account auto-created). */}
                  <Route path="/tft/:slug" component={RecipientInvitePage} />

                  <Route exact component={Snooze} path="/snooze/:snoozeId" />
                  <DrawerProvider>
                    <AuthorizedContext>
                      <ServerErrorPopup />
                      <BookPagesProvider >
                        <MobileDrawer>
                          <Route component={BabysFirstYear} path="/babys-first-year/get-started" />
                          <Route component={WatchMeGrowOnBoarding} path="/watch-me-grow/get-started" />

                          <Route component={BabysFirstYear} path="/redeem-gift-certificate/:id?" />

                          <Route component={GiftCertificate} path="/gift" />
                          {/* Not `exact` — the feature owns its own nested routes
                              (dashboard + the book set-up experience). */}
                          <Route component={AccountDashboard} path="/account" />
                          <Route exact component={ShopifyOnboardingPage} path="/shopify-onboarding" />
                          <Flex flexDirection="column">
                            {/* <Header /> */}
                            <Route exact path="/tell_a_story/:memoirStoryRequestId/:ref_source?" component={TellAStory} />
                            <Route exact path="/watch_me_grow/:mediaId?" component={FinalVideoPreview} />
                            <Route exact path="/founder-welcome" component={FounderWelcome} />
                            <Route exact path="/order-type" component={OrderType} />

                            {/* <AndroidSaveBanner /> */}
                            <Flex>
                              <DesktopSidebar />
                              <Box css="width: 100%;" >
                                <Switch>
                                  <Redirect
                                    from="/memoir/:memoirId/story_request/:storyRequestId"
                                    to="/memoirs/:memoirId/story-requests/:storyRequestId"
                                  />
                                  <Route path="/complete-get-started" component={CompleteOnboarding} />
                                  <Route path="/complete-profile" component={CompleteProfile} />
                                  {/* <Route path="/my-stories" component={MyStoriesPage} /> */}
                                  {/* <Route path="/shared-with-me" component={SharedWithMePage} /> */}
                                  <Route path="/(tell_a_story|stories|story)" component={Stories} />
                                  <Route path="/profile" component={Profile} />
                                  {/* <Route path="/friends" component={Friends} /> */}
                                  {/* <Route path="/notifications" component={Notifications} /> */}
                                  {/* <Route path="/memoirs" component={Memoir} /> */}
                                  {/* <Route path="/how-do-i" component={Memoir} /> */}
                                  {/* <Route path="/custom" component={Memoir} /> */}
                                  <Route path="/child-journals" component={Memoir} />
                                  {/* <Route path="/family-journals" component={Memoir} /> */}
                                  {/* <Route path="/personal-journals" component={Memoir} /> */}
                                  <Route
                                    path="/story-requests/:storyRequestId"
                                    component={StoryRequestDetail}
                                  />
                                  <Route path="/" component={LoginSignUp} exact />
                                  {/* <Redirect from="/collections" to="/my-stories" exact /> */}
                                  <Redirect from="/get-started" to="/babys-first-year/get-started" exact />
                                </Switch>
                              </Box>
                            </Flex>
                            <MobileNavigation />
                            <GlobalNewStory />
                            <UploadManager />
                          </Flex>
                        </MobileDrawer>
                      </BookPagesProvider>
                      <ModalRoutes />
                      <AppCheckmark />
                    </AuthorizedContext>
                  </DrawerProvider>
                </Switch>
              </Auth>
            </QueryContextProvider>
          </JSONAPIContext>
        </ServerErrorProvider>
      </AppContainer>
    </BrowserVersionsWrap>
  );
};

export default App;
